import { useSelector } from 'react-redux'

import { makeSelectDomain, makeSelectUser } from '@webapp/core/stores/global'
import { buildGuidedIntakeContactSalesUrl } from '../../utils'

interface IUseGuidedIntakePromoResult {
  contactSalesUrl: string
}

export const useGuidedIntakePromo = (): IUseGuidedIntakePromoResult => {
  const domain = useSelector(makeSelectDomain())
  const user = useSelector(makeSelectUser())

  const contactSalesUrl = buildGuidedIntakeContactSalesUrl({
    domain: domain ?? '',
    email: user?.email ?? '',
  })

  return { contactSalesUrl }
}
